<template>
    <div id="ibc-layout" >
        <div class="ibc-layout">
            <div class="ibc-people" :class="[mClassifySelectedIndex === 0 ? 'txt-selected' : 'txt-un-selected']" @click="ibcClassifyClick(0)">人气</div>
            <div class="line"></div>

            <!-- 
                :actions="startTimeList"
                @select="onStartTimeSelect"
             -->
            <van-popover v-model="mShowStartTimeDialog" trigger="click" class="ibc-flex-1" @closed="canScroll">
                <div class="dialog-layout">
                    <div class="dialog-row" v-for="(item,index) in mStartTimeList" :key="index" @click="onStartTimeSelect(index,item)"
                        v-bind:class="[index === mStartTimeSelectedIndex ? 'txt-selected' : 'txt-un-selected']">{{item.text}}
                    </div>
                </div>
                <template #reference>
                    <div class="ibc-flex-1" @click="ibcClassifyClick(1)">
                        <span :class="[mClassifySelectedIndex === 1 ? 'txt-selected' : 'txt-un-selected']">{{mStartTimeSelectedValue}}</span>
                        <img src="../images/ic_index_down.png"/>
                    </div>
                </template>
            </van-popover>
            <div class="line"></div>
            <van-popover v-model="mShowEndTimeDialog" trigger="click" class="ibc-flex-1" @closed="canScroll">
                <div class="dialog-layout">
                    <div class="dialog-row" v-for="(item,index) in mEndTimeList" :key="index" @click="onEndTimeSelect(index,item)"
                        v-bind:class="[index === mEndTimeSelectedIndex ? 'txt-selected' : 'txt-un-selected']">{{item.text}}
                    </div>
                </div>
                <template #reference>
                    <div class="ibc-flex-1" @click="ibcClassifyClick(2)">
                        <span :class="[mClassifySelectedIndex === 2 ? 'txt-selected' : 'txt-un-selected']">{{mEndTimeSelectedValue}}</span>
                        <img src="../images/ic_index_down.png"/>
                    </div>
                </template>
            </van-popover>
            <div class="line"></div>
            <van-popover v-model="mShowAddressDialog" trigger="click" class="ibc-flex-1" @closed="canScroll">
                <div class="dialog-layout">
                    <div class="dialog-row" v-for="(item,index) in mAddressList" :key="index" @click="onAddressSelect(index,item)"
                        v-bind:class="[index === mAddressSelectedIndex ? 'txt-selected' : 'txt-un-selected']">{{item.text}}
                    </div>
                </div>
                <template #reference>
                    <div class="ibc-flex-1" @click="ibcClassifyClick(3)">
                        <span class="txt-max-show" :class="[mClassifySelectedIndex === 3 ? 'txt-selected' : 'txt-un-selected']">{{mAddressSelectedValue}}</span>
                        <img src="../images/ic_index_down.png"/>
                    </div>
                </template>
            </van-popover>
        </div>
        <div class="ibc-list">
            <div class="ibc-empty" v-if="mNoAnyData">暂无数据</div>
            <van-pull-refresh v-show="!mNoAnyData" v-model="mIsRefresh" success-text="刷新成功" @refresh="onRefresh">
                <van-list v-model="mIsLoadMore" :immediate-check="false" :finished="mNoLoadMoreData"
                    finished-text="没有更多了" @load="onLoadMore" :error.sync="mLoadMoreError">
                    <div class="ibc-item" v-for="(item,index) in mList" :key="index" @click="itemClick(item)">
                        <p class="title">{{item.title}}</p>
                        <p class="txt1 m-t">求购数量：{{item.tails.kindsCount}}项</p>
                        <p class="txt1 m-t">交货地区：{{item.province}}{{item.city}}{{item.area}}</p>
                        <div class="line-inner"></div>
                        <p class="txt2 m-t">发布日期：{{formartData(item.created_time)}}</p>
                        <div class="ibc-bl m-t">
                            <span class="txt2 ibc-bl-b">已报价：<span class="txt3">{{item.tails.offerCount}}</span>家</span>
                            <span class="txt2 ibc-bl-b">剩余时间：<span class="txt3">{{getDay(item.expiration_date)}}</span>天</span>
                        </div>
                    </div>
                </van-list>
            </van-pull-refresh>
        </div>
    </div>
</template>
<script>
import { Popover } from 'vant';
import { Toast } from 'mint-ui';
export default {
    name:'',
    components: {
        Popover
    },
    props: {
        keyStr: {
            type: String,
            default: ''
        },
        fCids: {
            type: String,
            default: '-1'
        },
        sCids: {
            type: String,
            default: '-1'
        },
        tCids: {
            type: String,
            default: '-1'
        },
        buySearchIndex: { // 搜索按钮点击的次数
            type: Number,
            default: 0
        },
    },
    data () {
        return {
            mClassifySelectedIndex: -1, // 分类下标
            mList: [],
            mStartTimeList:[
                { id: 1, text: '不限' }, 
                { id: 2, text: '近一周' }, 
                { id: 3, text: '近一个月' }, 
                { id: 4, text: '近三个月' }
            ],
            mStartTimeSelectedIndex: 0,
            mStartTimeSelectedValue: '发布时间',
            mShowStartTimeDialog: false,
            mEndTimeList:[
                { id: 1, text: '不限' }, 
                { id: 2, text: '往后一周内' }, 
                { id: 3, text: '往后一个月' }, 
                { id: 4, text: '往后三个月' }
            ],
            mEndTimeSelectedIndex: 0,
            mEndTimeSelectedValue: '截止时间',
            mShowEndTimeDialog: false,
            mAddressList: [
                { text: '全部', value: -1 },
                { text: '北京市', value: 110000 },
                { text: '天津市', value: 120000 },
                { text: '河北省', value: 130000 },
                { text: '山西省', value: 140000 },
                { text: '内蒙古自治区', value: 150000 },
                { text: '辽宁省', value: 210000 },
                { text: '吉林省', value: 220000 },
                { text: '黑龙江省', value: 230000 },
                { text: '上海市', value: 310000 },
                { text: '江苏省', value: 320000 },
                { text: '浙江省', value: 330000 },
                { text: '安徽省', value: 340000 },
                { text: '福建省', value: 350000 },
                { text: '江西省', value: 360000 },
                { text: '山东省', value: 370000 },
                { text: '河南省', value: 410000 },
                { text: '湖北省', value: 420000 },
                { text: '湖南省', value: 430000 },
                { text: '广东省', value: 440000 },
                { text: '广西壮族自治区', value: 450000 },
                { text: '海南省', value: 460000},
                { text: '重庆市', value: 500000 },
                { text: '四川省', value: 510000 },
                { text: '贵州省', value: 520000 },
                { text: '云南省', value: 530000 },
                { text: '西藏自治区', value: 540000 },
                { text: '陕西省', value: 610000 },
                { text: '甘肃省', value: 620000 },
                { text: '青海省', value: 630000 },
                { text: '宁夏回族自治区', value: 640000 },
                { text: '新疆维吾尔自治区', value: 650000 },
                { text: '台湾省', value: 710000},
                { text: '香港特别行政区', value: 810000 },
                { text: '澳门特别行政区', value: 820000 }
            ],
            mAddressSelectedIndex: 0,
            mAddressSelectedValue: '所在地',
            mShowAddressDialog: false,
            mPageNo: 1, // 当前页码
            mPageSize: 10, // 一页显示的个数
            mState: 0, // 0：表示下拉刷新；1：表示加载更多
            mIsRefresh: false,
            mIsLoadMore: false,
            mNoAnyData: false,
            mNoLoadMoreData: false,
            mLoadMoreError: false,
            mKey: '',
            mFCids: '-1',
            mSCids: '-1',
            mTCids: '-1',
        }
    },
    methods: {
        ibcClassifyClick: function(index) {
            if (this.mClassifySelectedIndex === index) {
                return
            }
            this.mClassifySelectedIndex = index
            if (index === 0) { // 选中了人气
                this.mStartTimeSelectedIndex = 0
                this.mStartTimeSelectedValue = '发布时间'
                this.mEndTimeSelectedIndex = 0
                this.mEndTimeSelectedValue = '截止时间'
                this.toTop()
                this.onRefresh()
                this.canScroll()
            } else {
                this.stopScroll()
            }
        },
        onStartTimeSelect: function(index, item) {
            if (this.mStartTimeSelectedIndex === index) {
                console.log('相同的开始时间下标，不做任何处理')
                return
            }
            this.toTop()
            this.mStartTimeSelectedIndex = index
            this.mStartTimeSelectedValue = item.text
            this.mShowStartTimeDialog = false
            this.onRefresh()
        },
        onEndTimeSelect: function(index, item) {
            if (this.mEndTimeSelectedIndex === index) {
                console.log('相同的结束时间下标，不做任何处理')
                return
            }
            this.toTop()
            this.mEndTimeSelectedIndex = index
            this.mEndTimeSelectedValue = item.text
            this.mShowEndTimeDialog = false
            this.onRefresh()
        },
        onAddressSelect: function(index, item) {
            if (this.mAddressSelectedIndex === index) {
                console.log('相同的地区下标，不做任何处理')
                return
            }
            this.toTop()
            this.mAddressSelectedIndex = index
            this.mAddressSelectedValue = item.text
            this.mShowAddressDialog = false
            this.onRefresh()
        },
        itemClick: function(item) {
            this.$router.push({
                path: '/offerDetail',
                query: {
                    id: item.id
                }
            })
        },
        onRefresh: function() {
            this.mPageNo = 1
            this.mState = 0
            this.getListData()
        },
        onLoadMore: function() {
            this.mPageNo ++
            this.mState = 1
            this.getListData()
        },
        getListData: function() {
            let that = this
            this.utils.GET(this.getRequestUrl(), (resultData) => {
                that.callResultData(resultData)
            })
        },
        callResultData: function(resultData) {
            if (resultData.success) { // 请求成功
                const list = resultData.data.rows
                if (this.mState === 0) { // 下拉刷新
                    this.mIsRefresh = false
                    if (list === null || list.length <= 0) {
                        this.mNoAnyData = true
                        Toast('暂无数据')
                    } else {
                        this.mNoAnyData = false
                        this.mNoLoadMoreData = false
                        this.mList = list
                        let total = resultData.data.total.toString()
                        if (total === 1 || total === '1') {
                            this.mNoLoadMoreData = true
                        }
                    }
                } else if (this.mState === 1) { // 加载更多
                    this.mIsLoadMore = false
                    if (list === null || list.length <= 0) {
                        this.mNoLoadMoreData = true
                    } else {
                        this.mNoLoadMoreData = false
                        this.mList = this.mList.concat(list)
                    }
                    if (this.mLoadMoreError) {
                        this.mLoadMoreError = false
                    }
                }
            } else {
                Toast('网络不给力啊，再试一次吧！')
                if (this.mState === 0) { // 下拉刷新
                    this.mIsRefresh = false
                } else if (this.mState === 1) { // 加载更多
                    this.mLoadMoreError = true
                    this.mPageNo --
                }
            }
        },
        getRequestUrl: function() {
            var url = '?page=' + this.mPageNo + '&rows=' + this.mPageSize
            if (this.mClassifySelectedIndex === -1) { // 分类未选中
                 url += '&orderType=' 
            } else {
                if (this.mStartTimeSelectedIndex != 0 || this.mEndTimeSelectedIndex != 0) {
                    url += '&orderType=2' 
                    url += '&timeParam1=' + this.mStartTimeList[this.mStartTimeSelectedIndex].id + 
                    '&timeParam2=' + this.mEndTimeList[this.mEndTimeSelectedIndex].id
                } else {
                    url += '&orderType=1' 
                }
            }
            let addressBean = this.mAddressList[this.mAddressSelectedIndex]
            if (addressBean.value === -1) { // 地区选择的是全部
                url += '&area='
            } else {
                url += '&area=' + addressBean.text
            }
            url += '&key=' + this.mKey
            if (this.mFCids !== '-1') {
                url = url + '&fCids=' + this.mFCids
            } else {
                url = url + '&fCids='
            }
            if (this.mSCids !== '-1') {
                url = url + '&sCids=' + this.mSCids
            } else {
                url = url + '&sCids='
            }
            if (this.mTCids !== '-1') {
                url = url + '&tCids=' + this.mTCids
            } else {
                url = url + '&tCids='
            }
            let realUrl = this.accountUrl + '/wantBuy/wantBuyList2' + url

            return realUrl
        },
        formartData: function(time) {
            return time.toString().substring(0, time.indexOf(' '))
        },
        getDay: function(time) {
            var nowDate = new Date()
            var endData = new Date(time.split('-').join('/'))

            var nowTime = nowDate.getTime() // 当前时间戳
            var endTime = endData.getTime()

            var dateDiff = endTime - nowTime
            // 计算出相差天数
            var dayDiff = Math.ceil(dateDiff / (24 * 3600 * 1000)); 
            if (dayDiff < 0) {
                return 0
            } else {
                return dayDiff + 1
            }
        },
        stopScroll: function () { // 禁止滚动
            document.body.style.overflow = 'hidden'
        },
        canScroll: function () { // 取消滑动限制
            document.body.style.overflow = ''
        },
        toTop: function() {
            document.body.scrollTop = document.documentElement.scrollTop = 0
        },
        setBgColor: function(remove) {
            let doc = document.querySelector('body')
            if (remove) {
                doc.removeAttribute('style')
            } else {
                doc.setAttribute('style', 'background-color:#f2f2f2;')
            }
        },
    },
    created () {
        this.mKey = this.keyStr
        this.mFCids = this.fCids
        this.mSCids = this.sCids
        this.mTCids = this.tCids
        console.log('created')
        this.onRefresh()
        this.setBgColor(false)
    },
    watch: {
        keyStr: function(newVal) {
            this.mKey = newVal
            // this.onRefresh()
        },
        fCids: function(newVal) {
            this.mFCids = newVal
            // this.onRefresh()
        },
        sCids: function(newVal) {
            this.mSCids = newVal
            // this.onRefresh()
        },
        tCids: function(newVal) {
            this.mTCids = newVal
            this.onRefresh()
        },
        buySearchIndex: function(newVal) {
            this.onRefresh()
        }
    },
    destroyed() {
        this.setBgColor(true)
    }
}

</script>

<style lang='scss'>
    #ibc-layout {
        .van-popover[data-popper-placement^='bottom'] .van-popover__arrow {
            top: none;
            border-top-width: none;
            border-bottom-color: none;
        }
    }
</style>
<style lang='scss' scoped>
    #ibc-layout {
        width: 100%;
        // height: 100%;
        position: absolute;
    }
    .dialog-layout {
        max-height: 200px;
        overflow-y: auto;
        background-color: #ffffff;
        .dialog-row {
            height: 40px;
            width: 100px;
            text-align: center;
            line-height: 40px;
        }
    }
    .txt-un-selected {
        color: #808080;
        font-size: 12px;
    }
    .txt-selected {
        color: #c41335;
        font-size: 12px;
    }
    .txt-max-show {
        max-width: 70px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .line {
        height: 35px;
        width: 1px;
        background-color: #f2f2f2f2;
    }
    .ibc-layout {
        position: fixed;
        z-index: 100;
        display: flex;
        flex-direction: row;
        height: 35px;
        width: 100%;
        background-color: #ffffff;
        border-top-color: #f2f2f2;
        border-top-width: 1px;
        border-top-style: solid;

        .ibc-people {
            width: 65px;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
        }
        .ibc-flex-1 {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            flex: 1;
            img {
                width: 8px;
                height: 5px;
                margin-left: 8px;
            }
        }
    }
    .ibc-list {
        position: relative;
        margin-top: 35px;
        background: #f2f2f2;
        padding-bottom: 50px;
        .ibc-empty {
            height: 100px;
            line-height: 100px;
            text-align: center;
            font-size: 14px;
            color: #808080;
        }
    }
    .ibc-item {
        margin-left: 13px;
        margin-right: 13px;
        margin-top: 13px;
        padding: 13px;
        background-color: #ffffff;
        border-style: none;
        border-radius: 5px;

        .title {
            color: #000000;
            font-size: 16px;
            font-weight: bold;
        }
        .txt1 {
            color: #000000;
            font-size: 12px;
        }

        .txt2 {
            color: #808080;
            font-size: 12px;
        }

        .txt3 {
            color: #c41335;
        }

        .m-t {
            margin-top: 5px;
        }

        .line-inner {
            background-color: #f2f2f2;
            height: 0.1px;
            margin-top: 10px;
            margin-bottom: 10px;
        }

        .ibc-bl {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-content: center;

            .ibc-bl-b {
                flex: 1;
            }
        }
    }
    
</style>


// WEBPACK FOOTER //
// src/view/shopping/goods/index-buy-complex.vue